import styled from "styled-components";

export const ZoomAccessInfoContainer = styled.section`
  padding: 0 50px 0 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  border-radius: 16px;

  background: url("/assets/kelas-live/zoom-access-info-top-left.svg") left
      bottom no-repeat,
    url("/assets/kelas-live/zoom-access-info-top-right.svg") right top no-repeat,
    ${({ theme }) => theme.colors.green["200"]};
`;

export const ZoomAccessInfoImageWrapper = styled.figure`
  position: relative;
  margin: 0;
  justify-self: flex-start;
  width: 328px;
  height: 220px;
  bottom: -10px;
`;
export const ZoomAccessInfoMessage = styled.h3`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.brand[600]};
  font-weight: bold;
  line-height: 1.5;
  max-width: 460px;
`;

export const ZoomAccessInfoCTA = styled.a`
  text-decoration: none;
  padding: 12px 24px 12px 24px;
  border-radius: 6px;
  height: 46px;
  cursor: pointer;
  font-weight: bold;
  line-height: 22px;
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  outline: none;
  border: 0;
  width: auto;
  min-width: fit-content;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  background-color: ${({ theme }) => theme.colors.brand[500]};
  color: ${({ theme }) => theme.colors.white} !important;

  &:hover {
    background-color: ${({ theme }) => theme.colors.brand[600]};
  }
`;
